export default __webpack_public_path__ + "static/media/Thumbnail7.548da751.jpg";